import { useContext } from 'react';
import Logger from 'utilities/logger';
import { makeStyles } from '@material-ui/core/styles';
import withPermissionProtection from 'hoc/withPermissionProtection';

import SnackbarContext from 'context/Snackbar/Context';

import Button from 'components/CncUI/Button';
import Typography from 'components/CncUI/Typography';
import Tooltip from 'components/CncUI/Tooltip';

import useResetEmployeeAddress from './hooks/useResetEmployeeAddress';

import isSSN from 'utilities/validateSSN';
import isSIN from 'utilities/validateSIN';

const useStyles = makeStyles(({ spacing }) => ({
  button: {
    width: 150,
    marginTop: spacing(-1),
  },
  tooltip: {
    color: 'white',
  },
}));

const ClearCacheButton = ({ searchValue = '', idType = 'ssn' }) => {
  const classes = useStyles();
  const logger = Logger('ClearCacheButton');
  const notify = useContext(SnackbarContext);
  const clearCachedAddresses = useResetEmployeeAddress();
  const validator = idType.toLowerCase() === 'ssn' ? isSSN : isSIN;
  const clearCache = () => {
    const ssn = validator(searchValue) ? searchValue : null;
    if (!ssn) return;
    notify({
      show: true,
      message: `Attempting to clear cache for ${idType}: ${searchValue}`,
    });
    clearCachedAddresses(ssn)
      .then(result => {
        if (result) {
          notify({
            type: 'success',
            show: true,
            message: `Address cache cleared for ${idType}: ${searchValue}`,
          });
        } else {
          notify({
            type: 'warning',
            show: true,
            message: `No address cache found for ${idType}: ${searchValue}`,
          });
        }
      })
      .catch(e => {
        notify({
          type: 'error',
          show: true,
          message: `We ran into an issue clearing the cache. Please retry soon,
            or contact support if the issue persists.`,
        });
        logger.error(e);
      });
  };
  return (
    <Tooltip
      size="medium"
      position="right-center"
      content={
        <Typography className={classes.tooltip}>
          Clears the cached primary address received from payroll of the
          employee specified in search field above.
          <br />
          <br /> Works only with full SSN or SIN, not email.
        </Typography>
      }
    >
      <div>
        <Button
          id="ClearCacheButton"
          onClick={clearCache}
          disabled={!validator(searchValue)}
          className={classes.button}
          secondary
        >
          Clear Cache
        </Button>
      </div>
    </Tooltip>
  );
};

export default withPermissionProtection({
  permissions: 'employee_registrations:edit',
  fallback: null,
})(ClearCacheButton);
